import {PlacePresentationValueObject} from "../../../../../model/vo/content/place/PlacePresentationValueObject";
import {useStyles} from "../../../../../styles/mission/nplace_quiz/ver1";
import React, {useEffect, useState} from "react";
import {Button, Image, mergeClasses, Spinner} from "@fluentui/react-components";
import AnswerInput from "../../../nshop_place/common/AnswerInput";
import {BitMask, isVisible} from "../../../../../utils/bitmask";
import InquiryDialog from "../../common/InquiryDialog";
import {copyToClipboard, onHandleUrlBtn} from "../../../../../utils/nshopQuiz";
import {PlacePathJointEventIO} from "../../../../../io/content/place/PlacePathJointEventIO";
import {ErrorPage} from "../../../../../ui/mission/common/ErrorPage";
import DefaultImg from "../../../../../assets/iconImg/defaultImg.png";
import {PlacePathTypeString, resolvePlacePathType} from "../../../../../constant/PlaceMissionType";
import {Column, Row} from "../../../../../ui/admin/common/Layout";
import {Copy, KeyRound, Star, Trophy, Link, Bell, MapPin, MessageCircleQuestion, RotateCcw} from "lucide-react";
import OtherMissionBtn from "../../../pink_ver1/common/OtherMissionBtn";
import {PlaceEventType} from "../../../../../constant/EventType";
import AlertDialog from "../../../../../ui/mission/avatye/components/common/AlertDialog";

export default function Mission(
    { mediaCode, mediaId, data, isLoading, primaryColor, otherMissionBtnClick }:
    {
        mediaCode: string,
        mediaId: string,
        data: PlacePresentationValueObject | null,
        isLoading: boolean,
        primaryColor: string,
        otherMissionBtnClick: () => void
    }
) {
    const styles = useStyles();

    const [isEnd, setIsEnd] = useState(false)
    const [img, setImg] = useState<string | null>(null)
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [isInquiryDialogOpen, setIsInquiryDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState<string>('')
    const [dialogMsg, setDialogMsg] = useState<string>('')
    const [isCopied, setIsCopied] = useState(false)
    const [isAnswerInputVisible, setIsAnswerInputVisible] = useState<boolean>(false)

    const openDialog = (title: string, content: string, src: string | null) => {
        try {
            setDialogTitle(title)
            setDialogMsg(content)
            setImg(src)
        } finally {
            setIsDialogOpen(true)
        }
    }

    const closeDialog = () => setIsDialogOpen(false)

    useEffect(() => {
        const handleCopy = (e: ClipboardEvent) => {
            e.preventDefault()
            openDialog(
                '경고',
                '복사가 금지되어 있습니다.\n하단의 버튼을 이용해서 미션을 진행해주세요!',
                null
            )
        }

        document.addEventListener('copy', handleCopy)

        return () => {
            document.removeEventListener('copy', handleCopy)
        }
    }, [])

    useEffect(() => {

    }, []);


    if (isLoading)
        return <Spinner/>

    return (
        (!data || !data.visibility) ?
            <ErrorPage/>
            :
            <>
                <AlertDialog
                    title={dialogTitle}
                    description={dialogMsg}
                    isOpen={isDialogOpen}
                    onClose={closeDialog}
                />

                <main className={mergeClasses(styles.main, styles.flexColumn)}
                      style={{ alignItems: 'center', backgroundColor: primaryColor, height: '100vh' }}>

                    <div style={{ width: '100%', display: 'flex' }}>
                        <div style={{ marginLeft: 'auto', marginTop: '16px' }}
                             onClick={() => setIsInquiryDialogOpen(true)}>
                            <Bell width={60} color={'white'} style={{ cursor: 'pointer' }}/>
                        </div>
                        <InquiryDialog
                            isOpen={isInquiryDialogOpen}
                            onClose={() => setIsInquiryDialogOpen(false)}
                            setIsSubmit={() => setIsInquiryDialogOpen(false)}
                            userId={data.userId}
                            placePathJointId={data.placePathJointId}
                            primaryColor={primaryColor}
                        />
                    </div>

                    <div className={styles.guideMessage}
                         style={{ color: 'white' }}>
                        {BitMask.isEnabled(data.visibility, 3) && data.placeName &&
                            <Row alignItems={'center'} justifyContent={'center'} style={{
                                backgroundColor: 'white',
                                borderRadius: '50px',
                                padding: '8px',
                                fontSize: 'large',
                                gap: '4px',
                                boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.25)',
                            }}>
                                <MapPin color={primaryColor}/>
                                <div style={{
                                    color: 'black',
                                    marginRight: '8px'
                                }}>{data.placeName}</div>
                            </Row>
                        }
                        <div>{resolvePlacePathType(data.pathType, PlacePathTypeString)}</div>
                    </div>


                    {BitMask.isEnabled(data.visibility, 7) &&
                        <div className={styles.productImg}>
                            <Image
                                alt="상품이미지"
                                src={data.placeImageUrl || DefaultImg}
                                width={200}
                                height={200}
                            />
                        </div>
                    }

                    <div style={{
                        color: 'white',
                        fontSize: 'large',
                        textDecoration: 'underline',
                        marginRight: 'auto',
                        marginLeft: '5%',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.3rem'
                    }}>
                        <MessageCircleQuestion color={'white'}/>
                        힌트
                    </div>
                    <Column gap={'16px'} className={styles.placeInfoContainer}>
                        {BitMask.isEnabled(data.visibility, 6) &&
                            <Row gap={'8px'} alignItems={'center'}>
                                <div className={mergeClasses(styles.placeInfoHeader, styles.flexCenter)}
                                     style={{ backgroundColor: primaryColor }}>
                                    <KeyRound color={'white'}/>
                                </div>
                                <Column>
                                    <div style={{ color: primaryColor, fontSize: 'small' }}>검색 키워드</div>
                                    <div style={{ color: 'black', fontSize: 'large' }}>{data.keyword}</div>
                                </Column>
                            </Row>
                        }
                        {BitMask.isEnabled(data.visibility, 4) &&
                            <Row gap={'8px'} alignItems={'center'}>
                                <div className={mergeClasses(styles.placeInfoHeader, styles.flexCenter)}
                                     style={{ backgroundColor: primaryColor }}>
                                    <Trophy color={'white'}/>
                                </div>
                                <Column>
                                    <div style={{ color: primaryColor, fontSize: 'small' }}>플레이스 순위</div>
                                    <div style={{ color: 'black', fontSize: 'large' }}>{data.keywordRank + ' 위'}</div>
                                </Column>
                            </Row>
                        }
                        {data.attractionRank &&
                            <Row gap={'8px'} alignItems={'center'}>
                                <div className={mergeClasses(styles.placeInfoHeader, styles.flexCenter)}
                                     style={{ backgroundColor: primaryColor }}>
                                    <Star color={'white'}/>
                                </div>
                                <Column>
                                    <div style={{ color: primaryColor, fontSize: 'small' }}>명소 위치</div>
                                    <div style={{ color: 'black', fontSize: 'large' }}>{data.attractionRank + ' 번째 명소'}</div>
                                </Column>
                            </Row>
                        }
                    </Column>
                </main>

                {
                    !isAnswerInputVisible && (
                        <div className={mergeClasses(styles.fixedBottom, styles.flexRow)}
                             style={{ gap: '8px', backgroundColor: 'white' }}>
                            {BitMask.isEnabled(data.visibility, 0) && (
                                <Button
                                    icon={<Copy color={primaryColor}/>}
                                    className={mergeClasses(styles.roundedBtn)}
                                    style={{
                                        backgroundColor: 'white',
                                        border: `none`,
                                        flex: 1,
                                        color: primaryColor,
                                        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
                                    }}
                                    size="large"
                                    onClick={() => {
                                        copyToClipboard(
                                            data?.keyword || '',
                                            () => {
                                                openDialog("오류", "복사에 실패했습니다.", null);
                                                setTimeout(() => {
                                                    closeDialog();
                                                }, 10000);
                                                return;
                                            },
                                            () => {
                                                setIsCopied(true)
                                                if (data?.placePathJointId && data.userId) {
                                                    PlacePathJointEventIO.post({
                                                        placePathJointId: data.placePathJointId,
                                                        userId: data.userId,
                                                        misc: mediaId,
                                                        eventType: PlaceEventType.PlaceClipboardClick
                                                    }).then(
                                                        v => console.log(v)
                                                    ).catch(e => console.error(e))
                                                }
                                            },
                                            () => {
                                            }
                                        );
                                    }}
                                >
                                    검색어 복사하기
                                </Button>
                            )}

                            {isVisible(data.visibility, 1) && (
                                <Button
                                    icon={<Link color={'white'}/>}
                                    className={mergeClasses(styles.roundedBtn)}
                                    style={{
                                        backgroundColor: primaryColor,
                                        border: `1.5px solid ${primaryColor}`,
                                        flex: 1,
                                        color: 'white',
                                        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
                                    }}
                                    onClick={() => {
                                        onHandleUrlBtn(
                                            data.format || '',
                                            BitMask.isEnabled(data.visibility, 0),
                                            data.browser || '',
                                            isCopied,
                                            () => {
                                                openDialog('경고', '복사가 필요한 미션입니다!', null);
                                                setTimeout(() => {
                                                    closeDialog();
                                                }, 10000);
                                                return;
                                            },
                                            () => {
                                                if (data.placePathJointId && data.userId) {
                                                    PlacePathJointEventIO.post({
                                                        placePathJointId: data.placePathJointId,
                                                        userId: data.userId,
                                                        misc: mediaId,
                                                        eventType: PlaceEventType.PlaceMissionClick
                                                    }).then(
                                                        v => {
                                                            console.log(v)
                                                        }
                                                    ).catch(e => console.error(e))
                                                }
                                            }
                                        )
                                        if(isCopied) setIsAnswerInputVisible(true)
                                    }}
                                >
                                    미션하러 가기
                                </Button>
                            )}
                        </div>
                    )
                }
                {
                    data?.placePathJointId && data.userId && isAnswerInputVisible && (
                        <div className={styles.fixedBottom} style={{ padding: '0px' }}>
                            <div style={{ width: '100%', display: 'flex', gap: '0.3rem' }}>
                                <div style={{ backgroundColor: primaryColor }} className={styles.otherMissionContainer}>
                                    <RotateCcw color={'white'} size={'small'} width={20}/>
                                    <OtherMissionBtn onClick={otherMissionBtnClick}
                                                     style={{ backgroundColor: primaryColor }}
                                                     className={styles.otherMissionBtn}/>
                                </div>
                            </div>
                            <div style={{ marginTop: '16px' }}/>
                            <AnswerInput
                                mediaCode={mediaCode || ''}
                                placePathJointId={data.placePathJointId}
                                userId={data.userId}
                                mediaId={mediaId || ''}
                                onClickPreviousBtn={() => setIsAnswerInputVisible(false)}
                                data={data}
                            />
                        </div>
                    )
                }
            </>)
}